import * as React from "react";
import { setClassNamesMiniCard, getMarketsAmerican } from "../../../../helpers";
import { MiniEventCard } from "../MiniEventCard";
import { MiniMarketsWrapAmerican } from "../MiniMarketsWrapAmerican";
import { MiniCardDetails } from "../MiniCardDetails";
export class MiniEventCardAmerican extends MiniEventCard {
    render() {
        const details = Object.assign(Object.assign({}, this.props), { markets: getMarketsAmerican(this.props.sport.config.markets, this.props.markets, this.props.event, this.props.dict).markets });
        const classNames = setClassNamesMiniCard(details.event.isSelected, details.event.isInKickOffState, "mini-ev-card");
        const cardTypeClass = details.event.cardType
            ? `rj-ev-list__mini-ev-card--${details.event.cardType.toLowerCase()}`
            : "";
        return (React.createElement("div", { className: `rj-ev-list__mini-ev-card ${cardTypeClass} ${classNames}`, "data-uat": "div-ev-list-mini-ev-card" },
            React.createElement("div", { className: "rj-ev-list__mini-ev-card__inner", "data-uat": "div-ev-list-mini-ev-card-inner" },
                React.createElement(MiniCardDetails, { details: details, componentPrefix: "mini-ev-card" }),
                this.props.showOddBtns &&
                    React.createElement(MiniMarketsWrapAmerican, { details: details, componentPrefix: "mini-ev-card" }))));
    }
}
//# sourceMappingURL=MiniEventCardAmerican.js.map